import api from './create-api';
import { responseFormatter } from '@utils';

const getVersion = async () => {
  return responseFormatter(
    api.get('/', {
      setAuthHeader: true,
    })
  );
};

export default { getVersion };
